import { render, staticRenderFns } from "./ImportTwoWheel.vue?vue&type=template&id=20d97962&"
import script from "./ImportTwoWheel.vue?vue&type=script&lang=js&"
export * from "./ImportTwoWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports